import { onSnapshot } from 'firebase/firestore';

const readError = (code, message) => Object.assign(new Error(message), { code });

export const readTopSnapshot = (query, { signal, timeoutMs = 45000 } = {}) =>
  new Promise((resolve, reject) => {
    let settled = false;
    let unsubscribe = null;
    let timer = null;

    const cleanup = () => {
      if (timer !== null) clearTimeout(timer);
      timer = null;
      signal?.removeEventListener('abort', onAbort);
      if (unsubscribe) {
        const stop = unsubscribe;
        unsubscribe = null;
        stop();
      }
    };

    const finish = (error, snapshot) => {
      if (settled) return;
      settled = true;
      cleanup();
      if (error) reject(error);
      else resolve(snapshot);
    };

    const onAbort = () => finish(readError('cancelled', 'Caricamento TOP annullato.'));
    if (signal?.aborted) {
      onAbort();
      return;
    }

    timer = setTimeout(() => {
      finish(readError('deadline-exceeded', 'Tempo massimo di caricamento TOP superato.'));
    }, timeoutMs);
    signal?.addEventListener('abort', onAbort, { once: true });
    if (settled) return;

    try {
      unsubscribe = onSnapshot(query, { includeMetadataChanges: true }, (snapshot) => {
        if (settled || snapshot?.metadata?.fromCache !== false) return;
        finish(null, snapshot);
      }, (error) => finish(error));
      // A synchronous callback can settle before onSnapshot returns its disposer.
      if (settled) cleanup();
    } catch (error) {
      finish(error);
    }
  });
